import {LiftType, LiftTypeOverrides} from 'common/report/util/lift/types';
import {RetentionQuery} from 'common/report/retention/models/retention-query';
import {disableLiftTypeForChart} from 'common/report/util/lift';

export function getLiftTypeOverridesForRetention(bookmarkParams: RetentionQuery): LiftTypeOverrides {
  let overrides = {};

  const {chartType} = bookmarkParams;

  if (bookmarkParams.isAddiction()) {
    const reason = `Retention Frequency charts`;
    overrides = {
      [LiftType.Time]: disableLiftTypeForChart(LiftType.Time, chartType, reason),
      [LiftType.Segment]: disableLiftTypeForChart(LiftType.Segment, chartType, reason),
      [LiftType.Overall]: disableLiftTypeForChart(LiftType.Overall, chartType, reason),
    };
  }

  overrides[LiftType.Overall] = disableLiftTypeForChart(LiftType.Overall, chartType);

  return overrides;
}
